<template>
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.9995" cy="17" r="16.5" fill="#F4F4F4"/>
<path d="M20.6613 11.6744C20.8512 11.4845 21.0777 11.3895 21.3407 11.3895C21.6183 11.3749 21.8521 11.4626 22.042 11.6525C22.2319 11.8424 22.3342 12.0762 22.3488 12.3538C22.3488 12.6168 22.2465 12.8506 22.042 13.0551L18.0752 17.0219L22.0201 20.9668C22.2246 21.1713 22.3269 21.4051 22.3269 21.6681C22.3269 21.9311 22.2319 22.1576 22.042 22.3475C21.8521 22.5374 21.6256 22.6324 21.3626 22.6324C21.085 22.6178 20.8512 22.5155 20.6613 22.3256L16.7164 18.3807L12.7496 22.3475C12.5597 22.5374 12.3259 22.6397 12.0483 22.6543C11.7707 22.6397 11.5369 22.5374 11.347 22.3475C11.1571 22.1576 11.0621 21.9311 11.0621 21.6681C11.0767 21.3905 11.179 21.1567 11.3689 20.9668L15.3357 17L11.3908 13.0551C11.1863 12.8506 11.084 12.6168 11.084 12.3538C11.0694 12.0762 11.1571 11.8424 11.347 11.6525C11.5369 11.4626 11.7707 11.3749 12.0483 11.3895C12.3113 11.3895 12.5451 11.4918 12.7496 11.6963L16.6945 15.6412L20.6613 11.6744Z" fill="#9B9B9B"/>
</svg>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    path, circle {
        transition: all 0.2s ease ;
    }
    &:hover {
        path {
            fill: #F4F4F4 !important;
        }
        circle {
            fill: #9B9B9B;
        }
    }
}
</style>